module.exports = __webpack_public_path__ + "img/interface_pri1.83bc238d.png";